import React from "react";

import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatting, metrics } from "@north-beam/nb-common";

export const JourneyDataFormatter = ({
  column,
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  let value = row[column.name];
  const { user } = useUser();

  let percentage = "";
  const sum = row[`${column.name}Sum`];
  if (sum) {
    percentage = formatting.formatMetric(
      value / sum,
      metrics.MetricTypes.PERCENTAGE,
      {
        precision: "approximate",
      },
    );
  }

  if (column.name.includes("revenue")) {
    value = formatting.formatMetric.currency.exact(row[column.name], {
      code: user.currencies.currentCurrency,
    });
  }

  return (
    <div>
      <div>{value}</div>
      {percentage && (
        <div className="text-xxs tracking-wider text-gray+3 font-light font-sans">
          ({percentage} of total)
        </div>
      )}
    </div>
  );
};
